import React, { Component } from 'react';

import {AppProvider , Layout , Page , Frame} from '@shopify/polaris';

import './index.css';
import translations from '@shopify/polaris/locales/en.json';

class PrivacyPolicy extends Component {

  state = {};

  // 进入组件调用
  componentDidMount() {
    // 设置页面标题
    document.title = 'DropshipMan';
  }

  render() {

    return (
      <div className="home_loading_page">
      <AppProvider i18n={translations}>
        <Frame >
          <Page
            // breadcrumbs={[{content: 'Dashboard', url: '/admin/dashboard'}]}
            // title={intl.get("Dropshipman")}
          >
            <Layout>
              <Layout.Section>
                <div style={{paddingTop:"60px", margin:'0 auto',textAlign:'center'}}>
                <div style={{height:'120px'}}>
                  <img width={120} src='/dropshipman-logo.png' alt='dropshipman' />
                </div>
               <div style={{height:'305px'}}>
                <img src='/home_loading.gif' alt='dropshipman' />
               </div>
               <p style={{fontSize:"20px"}}>Welcome to Dropshipman, Loading...</p>
               </div>
              </Layout.Section>
            </Layout>
          </Page>
        </Frame>
      </AppProvider>
      </div>
    );
  }
}

export default PrivacyPolicy;
